import { motion } from "framer-motion";

// Small utility: an editorial page header used across sub-pages.
export default function PageHeader({ eyebrow, title, italicTail, intro, meta }) {
  const parts = italicTail ? [title, italicTail] : [title];
  return (
    <section className="relative border-b border-ivory/[0.06] bg-ink-950 pb-16 pt-36 lg:pb-24 lg:pt-44">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="flex items-center gap-3 font-sans text-[11px] uppercase tracking-widest text-gold"
        >
          <span className="h-px w-10 bg-gold" />
          {eyebrow}
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1], delay: 0.1 }}
          className="mt-8 max-w-5xl font-display text-6xl leading-[0.95] tracking-tightest text-ivory lg:text-[8vw] xl:text-[7.5vw]"
        >
          {parts[0]}
          {italicTail ? (
            <>
              <br />
              <span className="italic text-gold">{italicTail}</span>
            </>
          ) : null}
        </motion.h1>

        {intro ? (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.25 }}
            className="mt-10 max-w-2xl font-sans text-lg leading-relaxed text-ivory-soft"
          >
            {intro}
          </motion.p>
        ) : null}

        {meta ? (
          <div className="mt-12 flex flex-wrap items-center gap-x-10 gap-y-4 border-t border-ivory/[0.06] pt-8 font-sans text-[11px] uppercase tracking-widest text-ivory-muted">
            {meta.map((m, i) => (
              <div key={i} className="flex items-center gap-3">
                <span className="text-gold">{m.label}</span>
                <span className="text-ivory">{m.value}</span>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
}
